<template>
  <CommonPageShell
    :title="text.create.page.title"
    :subtitle="text.create.page.subtitle"
    :actions="headerActions"
    @action="onHeaderAction"
  >
    <template #content>
      <section class="invoice-create-page">
        <InvoiceCreateTopSection
          :issuer="issuer"
          :customer-options="customerOptions"
          :selected-receiver="selectedReceiver"
          :tax-regime-options="taxRegimeOptions"
          :cfdi-use-options="cfdiUseOptions"
          :serial-options="serialOptions"
          :payment-method-options="paymentMethodOptions"
          :payment-form-options="paymentFormOptions"
          :global-invoice-periodicity-options="globalInvoicePeriodicityOptions"
          :invoice-info="invoiceInfo"
          :receiver-locked="receiverLocked"
          :inline-billing-data-only="inlineBillingDataOnly"
          :inline-customer-id="prefillPaymentCustomerId"
          @select-receiver="selectReceiver"
          @create-inline-customer="createInlineCustomer"
          @invoice-info-change="onInvoiceInfoChange"
        />

        <InvoiceCreateConceptsCard
          :concepts="concepts"
          :currency="currency"
          @add-concept="addConcept"
          @edit-concept="editConcept"
          @delete-concept="deleteConcept"
        />

        <InvoiceCreateConceptModal
          :show="showConceptModal"
          :mode="conceptModalMode"
          :initial-data="editingConceptData"
          :existing-concepts="concepts"
          :currency="currency"
          :prefill-payment-id="prefillPaymentId"
          :selected-receiver="selectedReceiver"
          @close="closeConceptModal"
          @submit="submitConceptFromModal"
        />

        <InvoiceCreateBottomSection
          :comments="comments"
          :discount-rate="discountRate"
          :subtotal="subtotal"
          :discount-amount="discountAmount"
          :transferred-tax-amount="transferredTaxAmount"
          :withheld-tax-amount="withheldTaxAmount"
          :total="total"
          :currency="currency"
          @comments-change="onCommentsChange"
        />

        <InvoiceCreateFooterActions
          @reset-draft="resetDraft"
          @preview="previewInvoice"
          @submit="submitInvoice"
        />
      </section>
    </template>
  </CommonPageShell>
</template>

<script>
import CommonPageShell from '@/components/common/CommonPageShell.vue';
import InvoiceCreateTopSection from '@/components/invoices/create/InvoiceCreateTopSection.vue';
import InvoiceCreateConceptsCard from '@/components/invoices/create/InvoiceCreateConceptsCard.vue';
import InvoiceCreateConceptModal from '@/components/invoices/create/InvoiceCreateConceptModal.vue';
import InvoiceCreateBottomSection from '@/components/invoices/create/InvoiceCreateBottomSection.vue';
import InvoiceCreateFooterActions from '@/components/invoices/create/InvoiceCreateFooterActions.vue';
import { useDomainText } from '@/composables/text/useDomainText';
import {
  createInvoiceCreateState,
  invoiceCreateComputed,
  invoiceCreateMethods,
} from '@/composables/invoices/useInvoiceCreatePage';

const { catalog: invoiceText } = useDomainText('invoices');
const { catalog: generalText } = useDomainText('general');

export default {
  name: 'InvoiceCreatePage',
  components: {
    CommonPageShell,
    InvoiceCreateTopSection,
    InvoiceCreateConceptsCard,
    InvoiceCreateConceptModal,
    InvoiceCreateBottomSection,
    InvoiceCreateFooterActions,
  },
  data() {
    return {
      text: invoiceText,
      generalText,
      ...createInvoiceCreateState(invoiceText),
    };
  },
  created() {
    this.initializePage();
  },
  computed: invoiceCreateComputed,
  methods: invoiceCreateMethods,
};
</script>
